import { GridPostParams } from 'common/models/utility-models/list-utility.model';

export class InternshipStudentListGridParams extends GridPostParams {
  typeOfStatus: any = '';
  year:any = '';
}
